export default "__VITE_ASSET__BYFYH1_Q__"